function NoPath() {
    return <p>404 Not found</p>
}

export default NoPath;